export default __webpack_public_path__ + "static/media/hht2_Intonation_04.d38f4e66.png";